module.exports = __webpack_public_path__ + "static/media/kayak.372f2505.png";